export enum AuthorityQuotation {
  MOVIMENTATION_QUOTATION_REQUEST_PURCHASE = '2.6.7',
  MOVIMENTATION_QUOTATION_CANCEL = '2.6.6',
  MOVIMENTATION_QUOTATION_SEND = '2.6.5',
  MOVIMENTATION_QUOTATION_EDIT = '2.6.4',
  MOVIMENTATION_QUOTATION_DELETE = '2.6.3',
  MOVIMENTATION_QUOTATION_ADD = '2.6.2',
  MOVIMENTATION_QUOTATION_VIEW = '2.6.1',
  MOVIMENTATION_QUOTATION_QUOTES = '2.6',
}
